<template>
	<div class="qromo-report-fiscalization">
		<AppCard title=" " class="mb-20" no-header>
			<template #body>
				<div class="general-drop-head" @click="methodsOpen = !methodsOpen">
					<div class="title">{{ getString('modes_summary') }}</div>
					<AppChevronIcon :direction="methodsOpen ? 'up' : 'down'" />
				</div>
				<div class="general-drop-body">
					<AppDropdown :collapsed="!methodsOpen" white>

						<div class="summaries-container">

							<!-- Counter sale -->
							<div class="summary-container" v-if="currentResults.modeCounter > 0 || currentResults.modeCounterPrevious > 0" @click="openCounterSale">
								<div class="summary-head">
									<div class="title">{{ getString('counter_sale') }}</div>
									<div class="value">
										<AppChevronIcon :direction="counterSaleOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!counterSaleOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeCounterBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeCounter"
													:last-period-value="currentResults.modeCounterPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeCounterCards"
													:last-period-value="currentResults.modeCounterCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeCounterCash"
													:last-period-value="currentResults.modeCounterCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeCounterOther"
													:last-period-value="currentResults.modeCounterOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- QR staff -->
							<div class="summary-container" v-if="currentResults.modeQrStaff > 0 || currentResults.modeQrStaffPrevious > 0" @click="openQrStaff">
								<div class="summary-head">
									<div class="title">{{ getString('qr_rooms_staff') }}</div>
									<div class="value">
										<AppChevronIcon :direction="qrStaffOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!qrStaffOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeQrStaffBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeQrStaff"
													:last-period-value="currentResults.modeQrStaffPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeQrStaffCards"
													:last-period-value="currentResults.modeQrStaffCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeQrStaffCash"
													:last-period-value="currentResults.modeQrStaffCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeQrStaffOther"
													:last-period-value="currentResults.modeQrStaffOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- QR customers -->
							<div class="summary-container" v-if="currentResults.modeQrOnline > 0 || currentResults.modeQrOnlinePrevious > 0" @click="openQrCustomers">
								<div class="summary-head">
									<div class="title">{{ getString('qr_rooms_customers') }}</div>
									<div class="value">
										<AppChevronIcon :direction="qrCustomersOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!qrCustomersOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeQrOnlineBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeQrOnline"
													:last-period-value="currentResults.modeQrOnlinePrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeQrOnlineCards"
													:last-period-value="currentResults.modeQrOnlineCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeQrOnlineCash"
													:last-period-value="currentResults.modeQrOnlineCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeQrOnlineOther"
													:last-period-value="currentResults.modeQrOnlineOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- Delivery staff -->
							<div class="summary-container" v-if="currentResults.modeDeliveryStaff > 0 || currentResults.modeDeliveryStaffPrevious > 0" @click="openDeliveryStaff">
								<div class="summary-head">
									<div class="title">{{ getString('delivery_staff') }}</div>
									<div class="value">
										<AppChevronIcon :direction="deliveryStaffOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!deliveryStaffOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeDeliveryStaffBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeDeliveryStaff"
													:last-period-value="currentResults.modeDeliveryStaffPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeDeliveryStaffCards"
													:last-period-value="currentResults.modeDeliveryStaffCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeDeliveryStaffCash"
													:last-period-value="currentResults.modeDeliveryStaffCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeDeliveryStaffOther"
													:last-period-value="currentResults.modeDeliveryStaffOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- Delivery customers -->
							<div class="summary-container" v-if="currentResults.modeDeliveryOnline > 0 || currentResults.modeDeliveryOnlinePrevious > 0" @click="openDeliveryCustomers">
								<div class="summary-head">
									<div class="title">{{ getString('delivery_customers') }}</div>
									<div class="value">
										<AppChevronIcon :direction="deliveryCustomersOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!deliveryCustomersOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeDeliveryOnlineBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeDeliveryOnline"
													:last-period-value="currentResults.modeDeliveryOnlinePrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeDeliveryOnlineCards"
													:last-period-value="currentResults.modeDeliveryOnlineCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeDeliveryOnlineCash"
													:last-period-value="currentResults.modeDeliveryOnlineCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeDeliveryOnlineOther"
													:last-period-value="currentResults.modeDeliveryOnlineOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- Takeaway staff -->
							<div class="summary-container" v-if="currentResults.modeTakeawayStaff > 0 || currentResults.modeTakeawayStaffPrevious > 0" @click="openTakeawayStaff">
								<div class="summary-head">
									<div class="title">{{ getString('takeaway_staff') }}</div>
									<div class="value">
										<AppChevronIcon :direction="takeawayStaffOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!takeawayStaffOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeTakeawayStaffBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeTakeawayStaff"
													:last-period-value="currentResults.modeTakeawayStaffPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeTakeawayStaffCards"
													:last-period-value="currentResults.modeTakeawayStaffCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeTakeawayStaffCash"
													:last-period-value="currentResults.modeTakeawayStaffCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeTakeawayStaffOther"
													:last-period-value="currentResults.modeTakeawayStaffOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

							<!-- Takeaway customers -->
							<div class="summary-container" v-if="currentResults.modeTakeawayOnline > 0 || currentResults.modeTakeawayOnlinePrevious > 0" @click="openTakeawayCustomers">
								<div class="summary-head">
									<div class="title">{{ getString('takeaway_customers') }}</div>
									<div class="value">
										<AppChevronIcon :direction="takeawayCustomersOpen ? 'up' : 'down'" />
									</div>
								</div>
								<div class="summary-body">
									<AppDropdown :collapsed="!takeawayCustomersOpen" white>
										<div class="container-mini-cards-total">
											<div class="container-mini-card">
												<UserInitialCardInfo
													@click.stop="$emit('openBreakdown', currentResults.modeTakeawayOnlineBreakdown)"
													class="dark-blue"
													blue :title="getString('total')"
													:value="currentResults.modeTakeawayOnline"
													:last-period-value="currentResults.modeTakeawayOnlinePrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_electronic')"
													:value="currentResults.modeTakeawayOnlineCards"
													:last-period-value="currentResults.modeTakeawayOnlineCardsPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_cash')"
													:value="currentResults.modeTakeawayOnlineCash"
													:last-period-value="currentResults.modeTakeawayOnlineCashPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
											<div class="container-mini-card">
												<UserInitialCardInfo
													blue :title="getString('total_other')"
													:value="currentResults.modeTakeawayOnlineOther"
													:last-period-value="currentResults.modeTakeawayOnlineOtherPrevious"
													:symbol="currencyStore.currCurrency.symbol"
													:with-cents="true"
													:no-currency="false" />
											</div>
										</div>
									</AppDropdown>
								</div>
							</div>

						</div>

					</AppDropdown>
				</div>
			</template>
		</AppCard>
	</div>
</template>

<script>
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useAnalyticsStore, usePrintersStore, useUserStore} from "@/console-new/stores";
import UserInitialCardInfo from "@/user/components/analytics/UserInitialCardInfo.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const analyticsStore = useAnalyticsStore();
		const printersStore = usePrintersStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		return {
			getString: languageStore.getString,
			userStore,
			analyticsStore,
			printersStore,
			notificationStore,
			currencyStore,
		}
	},
	name: "QromoReportMethods",
	emits: ['openBreakdown'],
	components: {UserInitialCardInfo, AppButtonIcon, AppCard, AppChevronIcon, AppDropdown},
	data() {
		return {
			methodsOpen: false,
			counterSaleOpen: true,
			qrStaffOpen: false,
			qrCustomersOpen: false,
			deliveryStaffOpen: false,
			deliveryCustomersOpen: false,
			takeawayStaffOpen: false,
			takeawayCustomersOpen: false,
		}
	},
	props: {
		currentResults: {type: Object, required: true},
	},
	methods: {
		openCounterSale() {
			this.counterSaleOpen = !this.counterSaleOpen;
			this.qrStaffOpen = false;
			this.qrCustomersOpen = false;
			this.deliveryStaffOpen = false;
			this.deliveryCustomersOpen = false;
			this.takeawayStaffOpen = false;
			this.takeawayCustomersOpen = false;
		},
		openQrStaff() {
			this.qrStaffOpen = !this.qrStaffOpen;
			this.counterSaleOpen = false;
			this.qrCustomersOpen = false;
			this.deliveryStaffOpen = false;
			this.deliveryCustomersOpen = false;
			this.takeawayStaffOpen = false;
			this.takeawayCustomersOpen = false;
		},
		openQrCustomers() {
			this.qrCustomersOpen = !this.qrCustomersOpen;
			this.counterSaleOpen = false;
			this.qrStaffOpen = false;
			this.deliveryStaffOpen = false;
			this.deliveryCustomersOpen = false;
			this.takeawayStaffOpen = false;
			this.takeawayCustomersOpen = false;
		},
		openDeliveryStaff() {
			this.deliveryStaffOpen = !this.deliveryStaffOpen;
			this.counterSaleOpen = false;
			this.qrStaffOpen = false;
			this.qrCustomersOpen = false;
			this.deliveryCustomersOpen = false;
			this.takeawayStaffOpen = false;
			this.takeawayCustomersOpen = false;
		},
		openDeliveryCustomers() {
			this.deliveryCustomersOpen = !this.deliveryCustomersOpen;
			this.counterSaleOpen = false;
			this.qrStaffOpen = false;
			this.qrCustomersOpen = false;
			this.deliveryStaffOpen = false;
			this.takeawayStaffOpen = false;
			this.takeawayCustomersOpen = false;
		},
		openTakeawayStaff() {
			this.takeawayStaffOpen = !this.takeawayStaffOpen;
			this.counterSaleOpen = false;
			this.qrStaffOpen = false;
			this.qrCustomersOpen = false;
			this.deliveryStaffOpen = false;
			this.deliveryCustomersOpen = false;
			this.takeawayCustomersOpen = false;
		},
		openTakeawayCustomers() {
			this.takeawayCustomersOpen = !this.takeawayCustomersOpen;
			this.counterSaleOpen = false;
			this.qrStaffOpen = false;
			this.qrCustomersOpen = false;
			this.deliveryStaffOpen = false;
			this.deliveryCustomersOpen = false;
			this.takeawayStaffOpen = false;
		},
	},
}
</script>

<style scoped lang="scss">
.container-mini-cards-total {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	--gap-size: 8px;
	gap: var(--gap-size);
	background-color: var(--color-bg);
	border-radius: 13px;
	padding: 10px;
	box-shadow: inset 0 1px 2px var(--color-alpha-4);

	.container-mini-card {
		width: calc(25% - var(--gap-size));
		border: 1px solid transparent;

		.dark-blue {
			background-color: var(--color-bg-primary-2);
			border: 1px solid var(--color-primary);
			cursor: pointer;
		}

		@media (max-width: 1439px) {
			width: calc(50% - var(--gap-size));
		}

		@media (max-width: 500px) {
			width: 100%;
		}
	}
}
.general-drop-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 12px;
	background-color: var(--color-bg-primary-3);
	border-radius: 13px;
	cursor: pointer;

	.title {
		font-size: 16px;
		font-weight: 500;
	}
}
.general-drop-body {

	:deep(.dropdown-content) {
		box-shadow: none !important;
		padding: 0 !important;
	}

	.summaries-container {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.summary-container {
		background-color: var(--color-bg-primary-2);
		border-radius: 13px;
		padding: 10px 11px;
		border: 1px solid var(--color-alpha-4);
		cursor: pointer;

		.summary-head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			min-height: 34px;

			.title {
				font-size: 16px;
				font-weight: 500;
			}

			.value {
				display: flex;
				align-items: center;
				gap: 8px;
				font-size: 14px;
				color: var(--color-txt-1);

				.counter-container {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 4px;
					font-size: 14px;
					color: var(--color-txt-1);
					background-color: #fff;
					border-radius: 7px;
					padding: 8px;
					box-shadow: inset 0 1px 2px var(--color-alpha-4);
					min-width: 65px;

					.counter-value {
						font-weight: 700;
					}
				}
			}

		}
	}
}
</style>